/**
 * Цвет
 */
enum TirPmTagStateEnum {
  /**
   * Не активен
   * */
  DisabledState = 'disabled',
  /**
   * Активен
   */
  SelectedState = 'selected'

}
export default TirPmTagStateEnum;
